module.exports = __webpack_public_path__ + "bd-fin.png?8116502acae4488f19d4c10fc3fe5fd9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bd-fin.png
// module id = 198
// module chunks = 0